import React from 'react';

const WarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.50397 2.87296C5.94211 1.93409 6.88439 1.33398 7.92046 1.33398H8.07941C9.11548 1.33398 10.0578 1.93409 10.4959 2.87296L14.6719 11.8216C15.2907 13.1475 14.3228 14.6673 12.8595 14.6673H3.14033C1.67709 14.6673 0.709178 13.1475 1.32796 11.8215L5.50397 2.87296ZM7.99993 4.00065C8.36812 4.00065 8.6666 4.29913 8.6666 4.66732V9.33398C8.6666 9.70217 8.36812 10.0007 7.99993 10.0007C7.63174 10.0007 7.33327 9.70217 7.33327 9.33398V4.66732C7.33327 4.29913 7.63174 4.00065 7.99993 4.00065ZM7.99993 12.334C8.46017 12.334 8.83327 11.9609 8.83327 11.5007C8.83327 11.0404 8.46017 10.6673 7.99993 10.6673C7.5397 10.6673 7.1666 11.0404 7.1666 11.5007C7.1666 11.9609 7.5397 12.334 7.99993 12.334Z"
      fill="#F0384A"
    />
  </svg>
);

export default WarningIcon;
